import { config } from '~/config';

export const AUTH_REDIRECT_URL = `${config.authFrontUrl}/passport/sendbot`;
